export default "__VITE_ASSET__9cd6ef4f__"